<template>
  <van-nav-bar :title='tools.GetLanguageValue("public.app.套餐")' />

  <div class="collection_title_menu">
    <div class="collection_content">
      <div class="collection_items">
        <div class="collection_item">
          <van-card
            currency=""
            :price="Collection.PriceFormat"
            :desc="Collection.Desc"
            :title="Collection.Name"
            thumb="https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg"
          >
            <template #tags> </template>
            <template #footer>
              <h1 v-if="!Collection.IsAdd">   {{ tools.GetLanguageValue("public.app.已点") }}  {{ Collection.Count }}</h1>
              <van-stepper
                v-model="Count"
                min="1"
                max="1000"
                v-if="Collection.IsAdd"
              />
              <van-button
                v-if="Collection.IsAdd"
                @click="AddCollectionConfirm(Collection)"
              >
                 {{ tools.GetLanguageValue("public.app.添加") }}
              </van-button>
            </template>
          </van-card>
        </div>
        <p></p>
        <div class="productsubdivisions_title">
          <div>{{ tools.GetLanguageValue("public.app.可选数量") }} </div>
        </div>

        <div class="productSubdivisions">
          <div class="productsubdivisions_info">
            <van-badge :content="Collection.Rest">
              {{ tools.GetLanguageValue("public.app.其他") }}</van-badge
            >
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="Collection.Drinks">
              {{ tools.GetLanguageValue("public.app.饮料") }}
            </van-badge>
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="Collection.Sweetmeats">
              {{ tools.GetLanguageValue("public.app.甜点") }}</van-badge
            >
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="Collection.Foodstuff">
              {{ tools.GetLanguageValue("public.app.食品") }}</van-badge
            >
          </div>
        </div>
        <br />
        <p
          style="padding: 5px"
          v-if="Collection.StoreCollectionItemResults.length > 0"
        ></p>
        <div
          v-for="(item, index) in Collection.StoreCollectionItemResults"
          :key="index"
        >
          <div class="edit_collection">
            <van-row>
              <van-col span="16">
                <van-button type="primary" block @click="EditCollection(item)"
                  >
                       {{ tools.GetLanguageValue("public.app.继续点餐") }}
                  </van-button
                ></van-col
              >
              <van-col span="6"> {{ tools.GetLanguageValue("public.app.已选") }} {{ item.ItemCount }}</van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabbar active="storeCollection" />
</template>
<script >
import axios from "../../commons/AxiosMethod.js"
import tools from "../../commons/tools.js"
import productBbroadwise from "../../components/productBroadwise.vue"

import tabbar from "../../components/tabbars/storeTabbar.vue"
import { showToast } from "vant"

import { Collapse, CollapseItem, Tab, Tabs, showDialog } from "vant"

export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      tools: tools,
      TableId: "",
      active: "",
      CollectionList: [], // 合集列表
      CollectionOpt: {}, // 当前分类

      Collection: {
        StoreCollectionItemResults: []
      },
      Count: 1
    }
  },
  name: "App",
  mounted () {
    this.TableId = localStorage.getItem("Cache-TableId")
    this.GetCollectionById()
  },
  components: {
    productBbroadwise,
    tabbar
  },
  methods: {
    // 继续点餐
    EditCollection (item) {
      this.$router.push({
        path: "storeCollectionItems",
        query: {
          cartId: item.Id,
          collectionId: this.Collection.ProductId
        }
      })
    },
    // 获取合集
    GetCollectionById () {
      axios.apiMethod(
        "/shoppings/Collection/GetCollectionById",
        "get",
        {
          Id: localStorage.getItem("FixedTaoCan"),
          tableId: this.TableId
        },
        (result) => {
          if (result.Data.IsSuccess) {
            this.Collection = result.Data
          } else {
            showToast(result.Data.Msg)
          }
        }
      )
    },
    AddCollectionConfirm (item) {
      if (this.Collection.StoreCollectionItemResults.length == 0) {
        this.AddCollection(item)
      } else {
        showDialog.confirm({
          title: "添加提示",
          message:
            "您已经添加了" +
            this.Collection.StoreCollectionItemResults.length +
            "个套餐，确定要继续添加吗？"
        })
          .then(() => {
            this.AddCollection(item)
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 新增合集
    AddCollection (item) {
      axios.apiMethod(
        "/Store/StoreOrder/AddShoppingCart",
        "post",
        {
          ProductId: item.ProductId,
          Count: this.Count,
          Remarks: "",
          TableId: this.TableId
        },
        (result) => {
          console.log(JSON.stringify(result.Data))
          if (result.Data.IsSuccess) {
            this.$router.push({
              path: "storeCollectionItems",
              query: {
                cartId: result.Data.Model,
                collectionId: item.ProductId
              }
            })
          } else {
            showToast(result.Data.Msg)
          }
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.collection_title_menu {
  .collection_content {
    .collection_items {
      background-color: #fff;
      .collection_item {
        margin-top: 10px;
      }
    }
  }
}
.productSubdivisions {
  width: 100%;
  height: 40px;
  display: flex;
  justify-items: center;

  .productsubdivisions_info {
    width: 24%;
    padding: 2px;
    text-align: center;
    border: 1px solid #eee;
  }
}
.productsubdivisions_title {
  padding: 10px 20px;
  font-size: 13pt;
  border-bottom: 1px solid #eee;
}
.edit_collection {
  padding: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>
